import React from "react";
import { Button } from "@mui/material";
import recordcircle from "../../../assets/images/record-circle.png";
import location from "../../../assets/images/location.png";
import downloadicon from "../../../assets/images/downloadicon.png";
import calendar from "../../../assets/images/calendar.png";
import { Link, useNavigate } from "react-router-dom";
import {
  OrderResultMain,
  OrderResultItem,
  CancelButton,
  AddressSpan,
} from "./styles/OrderResultStyle";
import { formatDateTime } from "../../../helpers/DateFormate";
import Tooltip from "@mui/material/Tooltip";

// formatDateTime

const OrderResult = ({
  order_id = "",
  stops = [],
  StatueTime = "",
  status = "",
  HandelCancel = () => {},
  cancenLoading = false,
}) => {
  const navigate = useNavigate();
  const formattedStatus = status?.replace(/_/g, " ");

  return (
    <OrderResultMain>
      <OrderResultItem className="orders_ids">
        <span>Order-ID</span>
        <span>-</span>
        <Link to={`/order-details?id=${order_id}`}>{order_id}</Link>
      </OrderResultItem>

      {stops && stops.length > 0 && (
        <>
          <OrderResultItem className="locationsMain">
            {stops[0]?.location?.address && (
              <div className="OrderResult_text">
                <div className="pickup_ItemMain">
                  <img src={recordcircle} alt="Clothesbox" />
                  <Tooltip title={stops[0]?.location?.address} arrow>
                    <AddressSpan>{stops[0]?.location?.address}</AddressSpan>
                  </Tooltip>
                </div>
                {/* <div className="drop_ItemMain">
            <img src={location} alt="Clothesbox" />
            <span>121 Pike St, Marietta, OH </span>
          </div> */}
              </div>
            )}
            {status === "order_delivered" && (
              <>
                <div className="OrderResult_status">
                  <Button
                    disableRipple
                    startIcon={<img src={downloadicon} alt="Icon" />}
                    onClick={() => {
                      navigate(`/order-label?id=${order_id}`);
                    }}
                  />
                </div>
              </>
            )}
          </OrderResultItem>
        </>
      )}

      {stops && stops.length > 0 && (
        <>
          <OrderResultItem className="locationsMain">
            {stops[0]?.location?.address && (
              <div className="OrderResult_text">
                <div className="drop_ItemMain">
                  <img src={location} alt="Clothesbox" />
                  <Tooltip title={stops[0]?.location?.address} arrow>
                    <AddressSpan>{stops[1]?.location?.address}</AddressSpan>
                  </Tooltip>
                </div>
              </div>
            )}
            <div className="OrderResult_status">
              {/* inprogress */}
              <Tooltip title={formattedStatus} arrow>
                <span className={`${status}`}>{formattedStatus}</span>
              </Tooltip>
            </div>
          </OrderResultItem>
        </>
      )}

      <OrderResultItem>
        <div className="OrderResult_text calendarMain">
          <div className="drop_ItemMain">
            <img src={calendar} alt="Clothesbox" />
            <span>{formatDateTime(StatueTime)} </span>
          </div>
        </div>
        {status === "pending" && (
          <div className="OrderResult_status">
            <CancelButton
              onClick={() => HandelCancel(order_id)}
              disabled={cancenLoading}
            >
              Cancel
            </CancelButton>
          </div>
        )}
      </OrderResultItem>
    </OrderResultMain>
  );
};

export default OrderResult;
